import script from "./layout-one.vue?vue&type=script&setup=true&lang=js"
export * from "./layout-one.vue?vue&type=script&setup=true&lang=js"

import "./layout-one.vue?vue&type=style&index=0&id=7130e5b8&lang=css"

const __exports__ = script;

export default __exports__